// Imports
  // React
  import { useState, useEffect, useContext } from 'react';
  // Firebase
  import { addOrder, wapOrder, updateStock, updateStock2, cancelOrder } from '../firebase/FirebaseClient';
  import { Timestamp } from 'firebase/firestore';
  // Contexts
  import { CartContext } from '../context/CartContext';




// rafce

const CompleteOrder = ( ) => {

  // Context
    const { items, getPrice, clearItems } = useContext(CartContext);

  // Back to Cart Button
    const backToCart = () =>{
      document.getElementsByClassName('complete-order')[0].classList.remove('display-flex-from-right');
    }

  // Traigo la user info del form
    const [user, setUser] = useState({ name: "", phone: "", payment: "" })

    const userHandler = (event) => {
      setUser({
        ...user,
        [event.target.name] : event.target.value
      })
    }

  
  // Si abona en efectivo, le descuento el 10%
    const [price, setPrice] = useState( parseFloat(getPrice()) );
    
    useEffect(() => {
      setPrice(parseFloat(getPrice()))
      /* if(user.payment === "Efectivo"){
        let discount = parseFloat(getPrice()) * 0.9
        let rounded = (Math.round(discount * 1e2) / 1e2)
        setPrice(rounded)
        document.getElementsByClassName("cart-cash")[0].style.display = "none"
        document.getElementsByClassName("cart-discount")[0].style.display = "block"
      }
      else if(user.payment != "Efectivo"){
        setPrice(parseFloat(getPrice()));
        document.getElementsByClassName("cart-cash")[0].style.display = "block"
        document.getElementsByClassName("cart-discount")[0].style.display = "none"
      } */
    }, [items] )


  // Creo el objeto "order"
    const order = {
      buyer: user,
      cart: items,
      date: Timestamp.fromDate(new Date()),
      total: price,
    }

  // Actualizo el stock de Firestore
    const orderStockUpdater = () => {
      order.cart.map( i => {
        updateStock(i.id, parseInt(i.qty))
      })
      order.cart.map( i => {
        updateStock2(i.id, parseInt(i.qty))
      })
    }

  // Envío el order a Firestore
    const orderHandler = (event) => {
      event.preventDefault();
      addOrder(order);
      wapOrder(order);
      document.getElementsByClassName("complete-order-container")[0].style.display="none";
      document.getElementsByClassName("completed-order-message")[0].style.display="flex";
      document.getElementsByClassName("cancel-order-button")[0].style.visibility="visible";
      orderStockUpdater();
      setTimeout(clearItems, 50);
    }




  return (
    <>
      <div className='complete-order'>
        <div className="complete-order-container">
          <div>
            <button onClick={backToCart}>&#60;</button>
          </div>
          <h3> Completá tu Pedido</h3>
          <form className="complete-order-form" onSubmit={orderHandler}>
            <input
                  className="order-text-box"
                  name="name"
                  type="text"
                  required
                  placeholder="Ingrese su nombre..."
                  onChange={userHandler} />
            <input
                  className="order-text-box"
                  name="phone"
                  type="text"
                  minLength="5"
                  maxLength="15"
                  required
                  placeholder="Ingrese su teléfono..."
                  onChange={userHandler} />
            <div>
              <label className='payment-options'>
                Transferencia
                <input
                      name="payment"
                      type="radio"
                      required
                      value="Transferencia"
                      onChange={userHandler} />
              </label>
              <label className='payment-options'>
                Efectivo
                <input
                      name="payment"
                      type="radio"
                      required
                      value="Efectivo"
                      onChange={userHandler} />
              </label>
              <label className='payment-options'>
                Tarjeta
                <input
                      name="payment"
                      type="radio"
                      required
                      value="Tarjeta"
                      onChange={userHandler} />
              </label>
            </div>
            <span className="cart-price"> Total $  {price} </span>
            <span className="cart-cash">¡Aboná en efectivo y obtené un 10% off!</span>
            <span className="cart-discount">Incluye 10% off por pago en efectivo.</span>
            <input className="cart-button" type="submit" name="send" value="Confirmar Pedido"></input>
            <input className="cart-button" type="reset" name="reset" value="Borrar Datos"></input>
          </form>
        </div>
        <div className='completed-order-message'>
          <div className="cart-item-card">
            <span>¡Muchas gracias! Su pedido será confirmado el próximo día hábil de 08 a 16hs.</span>
          </div>
          <button className='cancel-order-button' onClick={()=> cancelOrder(order)}>Botón de Arrepentimiento</button>
        </div>
      </div>
    </>
  )
}

export default CompleteOrder
